import { HARC_DENETIM_KRITERI_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const basvuruHarcDenetimKriteriList = (basvuruId,stateId) => {
    return getRequest({url:HARC_DENETIM_KRITERI_LISTESI+"?basvuruId="+basvuruId+"&stateId="+stateId});
}

export default basvuruHarcDenetimKriteriList;